enum OwnershipTypeEnum {
    CrownLeasehold = 'CROWN_LEASEHOLD',
    Freehold = 'FREEHOLD',
    Leasehold = 'LEASEHOLD',
}

export default OwnershipTypeEnum;
